import React, { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { useNavigate } from "react-router-dom";
import amplitude from "../utils/amplitude";


const texts = [
  "skin analyst.",
"cosmetologist.",
"beauty guide.",
"AI consultant.",
"skincare app"
]


export default function LoadingScreen4() {
  const navigate = useNavigate();

    const [index, setIndex] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setIndex((prev) => (prev + 1) % texts.length);
    }, 2000); // меняется каждые 3 секунды

    return () => clearInterval(interval);
  }, []);


  useEffect(() => {
    // Установка CSS переменной --vh для корректной высоты экрана
    function setVh() {
      const vh = window.innerHeight * 0.01;
      document.documentElement.style.setProperty('--vh', `${vh}px`);
    }
    setVh();
    window.addEventListener('resize', setVh);

    // Amplitude и таймер перехода
    if(process.env.NODE_ENV === "production"){
      amplitude.track('Quiz Started', {
        option: "loading-4"
      });
      amplitude.track('Session Start', { platform: 'web' });
    }
    const timer = setTimeout(() => {
      navigate("/quiz1");
    }, 5000);

    return () => {
      clearTimeout(timer);
      window.removeEventListener('resize', setVh);
    };
  }, [navigate]);

  return (
    <div
      className="max-w-[450px] w-full mx-auto p-4 text-center font-sans bg-white flex flex-col justify-between border rounded-lg shadow-md"
      style={{ minHeight: "calc(var(--vh, 1vh) * 100)" }}
    >
      {/* Заголовок */}
      <div className="text-lg tracking-wider text-gray-500 px-2 pb-4">
        Please don’t close this page
      </div>

      {/* Изображение */}
      <div className="w-full h-64 sm:h-72 mb-9">
        <div className="w-full m-auto text-left" >
          <h1 className="flex font-semibold text-4xl">
            Sol
            <span className="flex items-center pt-1">
              <img
                src="solvi-icon.svg"
                alt="Solvi logo"
                className="w-6 h-6 sm:w-8 sm:h-8"
              />
            </span>
            i — your personal
          </h1>

          <AnimatePresence mode="wait">
        <motion.p
          key={texts[index]}
          className="font-semibold text-4xl text-pinkCustom absolute"
          initial={{ y: 50, opacity: 0, rotateX: 90 }}
          animate={{ y: 0, opacity: 1, rotateX: 0 }}
          exit={{ y: -20, opacity: 0, rotateX: -90 }}
          transition={{ duration: 0.8 }}
        >
          {texts[index]}
        </motion.p>
      </AnimatePresence>
        </div>
      </div>

      {/* Подвал */}
      <div className="text-[10px] text-gray-500 px-2 pb-4">
        Solvi: AI-powered personal skincare insights, cutting-edge analytical
        tools, and daily educational articles to keep you informed and glowing.
      </div>
    </div>
  );
}
